import gql from 'graphql-tag';

export const REJECT_FACEBOOK_IMPORT_REQUEST_MUTATION = gql`
  mutation RejectFacebookImportRequestMutation($requestId: Int!) {
    rejectFacebookImportRequest(requestId: $requestId) {
      errors
    }
  }
`;
